import { useNavigate } from "react-router-dom";
import { Loader } from "../../components/loader/Loader";
import { CircledCheveron } from "../../components/svg/GeneralIcons";
import { AppLayout } from "../../layout/AppLayout";
import { motion } from "framer-motion";
import Button from "../../components/button/Button";
import { Arrow } from "../../components/svg/Wallet/Wallet";

export const RedeemPoints = () => {
  const navigate = useNavigate();
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className="pt-16 pb-7 px-5 min-h-screen flex flex-col">
        <motion.div
          initial={{ opacity: 0, scale: 0.2 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="w-full relative flex flex-col flex-grow"
        >
          <div className="relative flex items-center justify-center mb-10">
            <Arrow
              onClick={() => navigate(-1)}
              stroke="#fff"
              className="text-lg absolute left-0 cursor-pointer"
            />
            <p className="font-bold text-xl text-black">Redeem</p>
          </div>

          <div className=" flex-grow flex justify-between items-center flex-col h-full gap-5">
            <div className="flex-grow flex items-center flex-col w-full">
              <img
                className="w-24 h-24"
                src="/image/convert_points.png"
                alt="points_convert_image"
                loading="lazy"
              />
              <div className="my-9 text-center">
                <div className="mb-2 ">
                  <p className="text-black text-3xl font-semibold">15,755</p>
                  <p className="text-base text-black font-semibold">
                    Available Points
                  </p>
                </div>
                <div className=" text-[#00000080] ">
                  <p className="text-sm font-normal">
                    Convert your points to wallet money
                  </p>
                  <p className=" text-sm font-semibold">5 points = ₦10 </p>
                </div>
              </div>
              <div className="w-full">
                <p className="text-xs text-[#00000080] font-medium">
                  ENTER POINTS
                </p>
                <div className="my-1 border border-[#0000004D] bg-white rounded-md px-3.5 pb-4 pt-3.5 flex justify-between items-center">
                  <div>
                    <span className="text-[#00000080] text-sm font-medium">
                      Points
                    </span>
                    <p className="text-lg font-semibold text-black">15,000</p>
                  </div>
                  <CircledCheveron />

                  <div>
                    <span className="text-[#00000080] text-sm font-medium">
                      You’ll get
                    </span>
                    <p className="text-lg font-semibold text-black">₦30,000</p>
                  </div>
                </div>
                <p className="text-[#2741D6CC] text-xs font-medium">
                  You need minimum of 500 points to redeem
                </p>
              </div>
            </div>
            <div className="mt-4 w-full">
              <Button
                onClick={() => navigate("/achievements/redeem-success")}
                text={"" ? <Loader type="bubbles" /> : "Redeem Now"}
                // className={isLoading && "!py-0"}
              />
            </div>
          </div>
        </motion.div>
      </div>
    </AppLayout>
  );
};
